module.exports = __webpack_public_path__ + "img/login_logo.72b90050.png";